import React, { useMemo } from 'react';
import { AutoFields, EditView } from '@builtbypixel/nucleus';
import setup from './setup';

const EditForm = () => {
    const fields = useMemo(
        () => [
            {
                group: 'Privacy Policy Category',
                fields: [
                    {
                        name: 'name',
                        component: 'text',
                        placeholder: 'Category Name',
                        label: 'Category Name',
                        isRequired: true,
                        rules: { required: true },
                    },
                ],
            },
        ],
        []
    );
    return (
        <EditView setup={setup} isFullWidth>
            <AutoFields fields={fields} />
        </EditView>
    );
};

export default EditForm;
